// extracted by mini-css-extract-plugin
export default {"multy--win":"MultyWin_multy--win__XFCo3"};